// extracted by mini-css-extract-plugin
export default {"footerSec":"Footers_footerSec__+TPKv","footer":"Footers_footer__TxOAm","ardillaLink":"Footers_ardillaLink__Q5SP7"};